import api from "@/lib/api";
import { cartItemsPayload } from "@/lib/customForm";

export function gokwikReady(config, country) {
  if (!config?.gokwik_checkout_active || !config?.gokwik_checkout?.mid) return false;
  if (country && String(country).toUpperCase() !== "IN") return false;
  return true;
}

export function loadGokwikSdk(scriptUrl) {
  return new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === "function") return resolve(true);
    const src = scriptUrl || "https://pdp.gokwik.co/v4/build/gokwik.js";
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(Boolean(window.gokwikSdk)));
      existing.addEventListener("error", () => resolve(false));
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve(Boolean(window.gokwikSdk && window.gokwikSdk.initCheckout));
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function openGokwikCheckout({ slug, items, country, couponCode, customerEmail, customerName, config, deliverySlotId }) {
  const gk = config.gokwik_checkout || {};
  const { data } = await api.post(`/store/${slug}/gokwik/session`, {
    ...cartItemsPayload(items, country),
    coupon_code: couponCode || null,
    customer_email: customerEmail || null,
    customer_name: customerName || null,
    delivery_slot_id: deliverySlotId || null,
  });
  const ok = await loadGokwikSdk(gk.script_url || data.script_url);
  if (!ok) {
    const err = new Error("Could not load GoKwik Checkout");
    err.code = "sdk";
    throw err;
  }
  const env = gk.environment || data.environment || "production";
  const mid = gk.mid || data.mid;
  const sessionId = data.session_id || data.merchant_checkout_id;
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      fn(value);
    };
    try {
      window.gokwikSdk.on("order-complete", (order) => {
        finish(resolve, { status: "complete", order, sessionId });
      });
      window.gokwikSdk.on("checkout-close", () => {
        finish(resolve, { status: "close", sessionId });
      });
      window.gokwikSdk.on("checkout-initiation-failure", (error) => {
        finish(reject, error || new Error("GoKwik checkout failed to start"));
      });
      window.gokwikSdk.initCheckout({
        environment: env,
        type: "merchantInfo",
        mid,
        merchantParams: { merchantCheckoutId: sessionId },
      });
    } catch (e) {
      finish(reject, e);
    }
  });
}
